import { TrackingEventNames as BaseTrackingEventNames } from '../../common/tracking/tracking-event-names.model';

export const TrackingEventNames = {
  ...BaseTrackingEventNames,
  FIRMWARES_SHELL: 'firmwares_shell',
  SENSORS_SHELL: 'sensors_shell',
  DEVICE_TEMPLATES: 'device_templates_shell',
  DEVICE_TEMPLATE_OVERVIEW: 'device_template_overview'
};
